export default __webpack_public_path__ + "static/media/patient-registration-form.eb566672.jpeg";